import { useApi } from '@backstage/core-plugin-api';
import type {
  ActivityCreationGateway,
  ActivityCreationJourney,
} from '../../activity-creation/contracts';
import { spassuCodeApiRef } from '../../api';
import { useProjectRole } from '../../hooks';
import { useCreationProviders } from './useCreationProviders';
import { useCreationContent } from './useCreationContent';
import { useCreationRepository } from './useCreationRepository';
import { useCreationBoard } from './useCreationBoard';
import { useCreationIssue } from './useCreationIssue';
import { useCreationFeedback } from './useCreationFeedback';
import { useCreationSubmission } from './useCreationSubmission';
import { creationDraft, resetCreationForm } from './creationForm';
import { CreationDialogView } from './CreationDialogView';

export interface CreateActivityDialogProps {
  open: boolean;
  onClose: () => void;
  onCreated?: () => void;
  journey?: ActivityCreationJourney;
  gateway?: ActivityCreationGateway;
}

export const CreateActivityDialog = (props: CreateActivityDialogProps) => {
  const api = useApi(spassuCodeApiRef);
  const permissions = useProjectRole();
  const feedback = useCreationFeedback();
  const content = useCreationContent();
  const providers = useCreationProviders(props.open);
  const repository = useCreationRepository(
    api,
    props.open && providers.isAzure,
    permissions,
  );
  const issue = useCreationIssue(content.dispatch);
  const board = useCreationBoard({
    api,
    open: props.open,
    provider: providers.selected?.id,
    project: repository.value.project,
    permissions,
    dispatch: content.dispatch,
    setError: feedback.setError,
  });
  const form = { providers, repository, issue, board, content, feedback };
  const actions = useCreationSubmission(
    props,
    creationDraft(form, props.journey),
    feedback,
    () => resetCreationForm(form),
  );
  return (
    <CreationDialogView
      open={props.open}
      form={form}
      actions={actions}
      branchLabel={props.journey?.branchLabel ?? 'Branch base/destino do PR'}
    />
  );
};
